import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "../utils/Reveal";

const SkillsDescription = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
      className="text-left lg:pt-0"
    >
      <h2 className="font-medium text-2xl text-amber-500 dark:text-amber-200 mt-5 mb-5">
        <Reveal width="100%">
          My Technical Level
        </Reveal>
      </h2>

      <p className="text-sm font-light text-gray-800 dark:text-gray-300">
        I’m a {" "}
        <span className="font-semibold text-black dark:text-white">
          Fullstack Developer
        </span>{" "}
        with strong experience in modern web technologies such as{" "}
        <span className="font-semibold text-black dark:text-white">
          React, Next.js, Node.js, Python, and AWS
        </span>. I focus on building scalable, high-performance web
        applications that provide a smooth experience from frontend to backend.
      </p>

      <h2 className="font-semibold text-lg text-amber-500 dark:text-amber-200 mt-5">
        <Reveal width="100%">Frontend Development</Reveal>
      </h2>
      <p className="text-sm font-light">
        I create clean, responsive, and user-friendly interfaces using React,
        Next.js, TypeScript, and Tailwind CSS. My focus is on performance
        optimization, accessibility, and seamless user experiences across
        devices. I also have experience working with advanced state management
        (Redux, Zustand) and data visualization tools like Recharts.
      </p>

      <h2 className="font-medium text-lg text-amber-500 dark:text-amber-200 mt-5">
        <Reveal width="100%">Backend Development</Reveal>
      </h2>
      <p className="text-sm font-light">
        Node.js, Express.js, and Nest.js to design secure and efficient APIs. I also use Python for automation and data
        processing. My backend solutions are optimized for scalability and
        integrate easily with third-party APIs, Stripe payments, and AWS cloud
        services.
      </p>

      <h2 className="font-medium text-lg text-amber-500 dark:text-amber-200 mt-5">
        <Reveal width="100%">DevOps & Cloud</Reveal>
      </h2>
      <p className="text-sm font-light">
        I set up CI/CD pipelines using tools like GitHub Actions, Jenkins, and
        Docker to streamline deployments. I’m experienced with AWS infrastructure
        (EC2, Lambda, S3) and database optimization using PostgreSQL, MongoDB,
        and DynamoDB to ensure high reliability and performance.
      </p>

    </motion.div>
  );
};

export default SkillsDescription;
